import React, { useState } from 'react';
import { addDoc, collection } from 'firebase/firestore';
import { Box, Typography, Button } from '@mui/material';
import { db } from '../firebase';
import WorkshopModal from './WorkshopModal';
import { useNavigate } from 'react-router-dom';

const SubmitWorkshop = () => {
  const [modalOpen, setModalOpen] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    if (saving) return;
    setModalOpen(false);
    navigate('/');
  };

  const saveWorkshop = async (newWorkshop) => {
    setSaving(true);
    try {
      await addDoc(collection(db, 'workshops'), {
        ...newWorkshop,
        isApproved: false,
      });
      setSubmitted(true);
    } catch (err) {
      console.error('Błąd podczas zgłaszania warsztatu:', err);
      setError(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ textAlign: 'center', mt: 5 }}>
      {error ? (
        <>
          <Typography variant="h5" gutterBottom sx={{ color: 'white' }}>
            Wystąpił błąd
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: 'white' }}>
            Nie udało się zgłosić warsztatu. Sprawdź połączenie z internetem i
            spróbuj ponownie.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/')}
            sx={{ backgroundColor: '#22c55e', color: 'black' }}
          >
            Wróć na stronę główną
          </Button>
        </>
      ) : submitted ? (
        <>
          <Typography variant="h5" gutterBottom sx={{ color: 'white' }}>
            Zgłoszenie wysłane🎪
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: 'white' }}>
            Warsztat zostanie sprawdzony przez Infopunkt przed publikacją. Po
            zatwierdzeniu automatycznie pojawi się na tablicy.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/')}
            sx={{ backgroundColor: '#22c55e', color: 'black' }}
          >
            Wróć na stronę główną
          </Button>
        </>
      ) : (
        <WorkshopModal
          open={modalOpen}
          handleClose={handleClose}
          saveWorkshop={saveWorkshop}
          workshopToEdit={null}
          isOrganizer={false}
        />
      )}
    </Box>
  );
};

export default SubmitWorkshop;
